(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getting-started-26-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind() {
      document.querySelectorAll('[data-faq-list]').forEach(function (list) {
        if (list.__leafBound) return;
        list.__leafBound = true;

        list.querySelectorAll('[data-faq-toggle]').forEach(function (row) {
          row.addEventListener('click', function () {
            var isOpen = row.classList.contains('is-open');

            // close all
            list.querySelectorAll('[data-faq-toggle]').forEach(function (r) {
              r.classList.remove('is-open');
              r.setAttribute('aria-expanded', 'false');
              var pm = r.querySelector('.leaf-faq__pm'); if (pm) pm.textContent = '+';
              var body = r.nextElementSibling;
              if (body && body.hasAttribute('data-faq-body')) body.classList.remove('is-open');
            });

            // reopen if it wasn't already
            if (!isOpen) {
              row.classList.add('is-open');
              row.setAttribute('aria-expanded', 'true');
              var pm = row.querySelector('.leaf-faq__pm'); if (pm) pm.textContent = '–';
              var body = row.nextElementSibling;
              if (body && body.hasAttribute('data-faq-body')) body.classList.add('is-open');
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
    else bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getting-started-26-hero-razor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scrollHandler = null;

    function build() {
      var hero = document.querySelector('[data-gs-section="hero-razor"]');
      if (!hero) return;
      var target = hero.querySelector('[data-gs-chips]');
      if (!target) return;
      var placeholder = hero.querySelector('[data-gs-chips-placeholder]');

      var sources = document.querySelectorAll('[data-gs-menu="true"]');
      if (!sources.length) return;

      // --- build chips from sibling sections ---
      var frag = document.createDocumentFragment();
      sources.forEach(function (el) {
        var anchor = el.getAttribute('data-gs-anchor-id') || el.id;
        if (!anchor) return;
        var number = el.getAttribute('data-gs-menu-number') || '';
        var label = el.getAttribute('data-gs-menu-label') || '';

        var a = document.createElement('a');
        a.className = 'leaf-hero__chip';
        a.href = '#' + anchor;
        a.setAttribute('data-chip-anchor', anchor);

        if (number) {
          var n = document.createElement('span');
          n.className = 'n';
          n.textContent = number;
          a.appendChild(n);
        }
        a.appendChild(document.createTextNode(' ' + label));
        frag.appendChild(a);
      });

      target.innerHTML = '';
      target.appendChild(frag);

      // --- click-to-scroll ---
      target.querySelectorAll('.leaf-hero__chip').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          var id = chip.getAttribute('data-chip-anchor');
          var t = document.getElementById(id);
          if (t) {
            // offset for sticky chip nav + theme header
            var headerOffset = window.innerWidth <= 749 ? 56 + 48 : 65 + 48;
            var top = t.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });

      // --- combined scroll handler: sticky toggle + scroll-spy ---
      if (scrollHandler) window.removeEventListener('scroll', scrollHandler, { passive: true });

      function updateSticky() {
        var refTop = placeholder && placeholder.classList.contains('is-active')
          ? placeholder.getBoundingClientRect().top + window.pageYOffset
          : target.getBoundingClientRect().top + window.pageYOffset;
        var stickyOffset = window.innerWidth <= 749 ? 56 : 65;

        if (window.pageYOffset + stickyOffset >= refTop) {
          if (!target.classList.contains('is-sticky')) {
            target.classList.add('is-sticky');
            if (placeholder) placeholder.classList.add('is-active');
          }
        } else {
          if (target.classList.contains('is-sticky')) {
            target.classList.remove('is-sticky');
            if (placeholder) placeholder.classList.remove('is-active');
          }
        }
      }

      var lastActiveAnchor = null;
      function updateActiveChip() {
        // "active section = the one whose top has most recently crossed above the trigger line."
        // Trigger sits just below the sticky nav. This stays stable through short sections
        // — only one section at a time has its top in the range [-inf, trigger], and we pick
        // the one closest to trigger (the most recently crossed).
        var stickyH = window.innerWidth <= 749 ? 56 : 65;
        var chipsH = 48;
        var trigger = stickyH + chipsH + 40; // buffer below the sticky chip nav

        var current = null;
        var currentTop = -Infinity;
        sources.forEach(function (el) {
          var top = el.getBoundingClientRect().top;
          if (top <= trigger && top > currentTop) {
            current = el;
            currentTop = top;
          }
        });

        target.querySelectorAll('.leaf-hero__chip').forEach(function (c) { c.classList.remove('is-active'); });
        var anchor = current ? (current.getAttribute('data-gs-anchor-id') || current.id) : null;
        if (current) {
          var match = target.querySelector('.leaf-hero__chip[data-chip-anchor="' + anchor + '"]');
          if (match) {
            match.classList.add('is-active');
            // When the active chip changes, make sure it's visible inside the
            // horizontally-scrollable nav (mobile). Only scrolls the nav if the
            // active chip actually changed — never fights the user's own horizontal scroll.
            if (anchor !== lastActiveAnchor && target.scrollWidth > target.clientWidth) {
              var chipRect = match.getBoundingClientRect();
              var navRect = target.getBoundingClientRect();
              if (chipRect.left < navRect.left || chipRect.right > navRect.right) {
                var desired = match.offsetLeft - (target.clientWidth - match.offsetWidth) / 2;
                var maxScroll = target.scrollWidth - target.clientWidth;
                if (desired < 0) desired = 0;
                if (desired > maxScroll) desired = maxScroll;
                target.scrollTo({ left: desired, behavior: 'smooth' });
              }
            }
          }
        }
        lastActiveAnchor = anchor;
      }

      var ticking = false;
      scrollHandler = function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateSticky();
            updateActiveChip();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
      scrollHandler(); // initial paint
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    } else {
      build();
    }
    document.addEventListener('shopify:section:load', build);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getting-started-26-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind() {
      document.querySelectorAll('.leaf-ugc__card[data-ugc-chapter]').forEach(function (card) {
        if (card.__leafBound) return;
        card.__leafBound = true;
        card.addEventListener('click', function (e) {
          var id = card.getAttribute('data-ugc-chapter');
          if (!id) return;
          if (typeof window.playVideoById === 'function') {
            e.preventDefault();
            window.playVideoById(id);
            var theater = document.querySelector('[data-gs-section="video-theater"]');
            if (theater) theater.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
    else bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getting-started-26-video-theater"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var section = document.querySelector('[data-gs-section="video-theater"]');
      if (!section) return;

      // ---- hydrate chapter data ----
      var payload = section.querySelector('[data-chapter-data]');
      var data = { chapters: [] };
      try { data = JSON.parse(payload.textContent) || data; } catch (e) { /* noop */ }
      var byId = {};
      data.chapters.forEach(function (c) { byId[c.id] = c; });

      // ---- element refs ----
      var stage = section.querySelector('[data-stage]');
      var video = section.querySelector('[data-stage-video]');
      var poster = section.querySelector('[data-stage-poster]');
      var overlay = section.querySelector('[data-stage-overlay]');
      var bigPlay = section.querySelector('[data-stage-play]');
      var statePill = section.querySelector('[data-stage-state-pill]');
      var stateText = section.querySelector('[data-stage-state-text]');
      var soundPill = section.querySelector('[data-stage-sound-pill]');
      var soundText = section.querySelector('[data-stage-sound-text]');
      var fullscreenBtn = section.querySelector('[data-stage-fullscreen]');
      var fsEnterIcon = section.querySelector('.leaf-theater__fs-icon--enter');
      var fsExitIcon = section.querySelector('.leaf-theater__fs-icon--exit');
      var scrubTrack = section.querySelector('[data-scrub-track]');
      var scrubFill = section.querySelector('[data-scrub-fill]');
      var scrubThumb = section.querySelector('[data-scrub-thumb]');
      var endOverlay = section.querySelector('[data-stage-end]');
      var endReplay = section.querySelector('[data-end-replay]');
      var endReplayTitle = section.querySelector('[data-end-replay-title]');
      var endNext = section.querySelector('[data-end-next]');
      var endNextTitle = section.querySelector('[data-end-next-title]');

      // ---- state ----
      var currentChapter = null;
      var hasPlayed = false; // true after user's first explicit play for this chapter
      var hasPoster = false;

      // ---- session-scoped mute preference ----
      // Default muted. If the visitor unmutes once, remember that for the rest
      // of the session so subsequent chapters start unmuted — and vice versa.
      // Preview-loop (pre-play silent loop) always stays muted; this only applies
      // at full-playback start (startPlayback).
      var MUTE_KEY = 'gs26:theater:muted';
      function getMutedPref() {
        try {
          var v = window.sessionStorage.getItem(MUTE_KEY);
          return v === null ? true : v === '1';
        } catch (e) { return true; }
      }
      function setMutedPref(muted) {
        try { window.sessionStorage.setItem(MUTE_KEY, muted ? '1' : '0'); } catch (e) {}
      }

      function q(key) { return section.querySelector('[data-ctx="' + key + '"]'); }

      // ---- status pill rendering ----
      function renderStatus() {
        if (!video) return;
        if (hasPlayed) {
          if (statePill) statePill.hidden = false;
          if (stateText) stateText.textContent = video.paused ? 'PAUSED' : 'PLAYING';
        } else {
          if (statePill) statePill.hidden = true;
        }
        if (soundText) soundText.textContent = video.muted ? 'MUTED' : 'SOUND ON';
      }

      // ---- swap chapter ----
      function swap(id) {
        var c = byId[id];
        // defensive: try whitespace/case-normalized lookup as a fallback
        if (!c) {
          var key = String(id || '').trim();
          if (byId[key]) c = byId[key];
          else {
            var lower = key.toLowerCase();
            for (var k in byId) {
              if (String(k).trim().toLowerCase() === lower) { c = byId[k]; break; }
            }
          }
        }
        if (!c) {
          if (console && console.warn) {
            console.warn('[GS26 theater] Chapter ID not found:', id, 'Known IDs:', Object.keys(byId));
          }
          return;
        }
        currentChapter = c;
        hasPlayed = false;

        // hide end overlay when swapping
        if (endOverlay) endOverlay.hidden = true;

        // context column
        var title = q('title');
        if (title) {
          title.innerHTML = (c.title || '') +
            (c.script_subtitle ? '<span class="script">' + c.script_subtitle + '</span>' : '');
        }
        if (q('meta')) q('meta').textContent = c.meta || '';
        if (q('sub')) q('sub').innerHTML = c.read_intro || '';
        if (q('duration')) q('duration').textContent = c.duration || '';
        if (q('read-topic')) q('read-topic').textContent = c.read_topic || '';
        if (q('read-time')) q('read-time').textContent = c.read_time || '';
        if (q('read-steps')) q('read-steps').innerHTML = c.read_steps || '';

        // read bubble
        var bWrap = q('read-bubble');
        if (bWrap) {
          if (c.bubble_link_id) {
            bWrap.innerHTML =
              '<button type="button" class="leaf-bubble" data-bubble-target="' + c.bubble_link_id + '">' +
                '<span class="leaf-bubble__badge">' + (c.bubble_link_badge || '▸') + '</span>' +
                '<span class="leaf-bubble__body">' +
                  '<span class="leaf-bubble__label">' + (c.bubble_link_label || '') + '</span>' +
                  '<span class="leaf-bubble__desc">' + (c.bubble_link_desc || '') + '</span>' +
                '</span>' +
                '<span class="leaf-bubble__arrow">→</span>' +
              '</button>';
            var btn = bWrap.querySelector('[data-bubble-target]');
            btn.addEventListener('click', function () { swap(c.bubble_link_id); startPlayback(); });
          } else {
            bWrap.innerHTML = '';
          }
        }

        // caption
        if (q('caption-title')) q('caption-title').textContent = c.title || '';
        if (q('caption-meta')) q('caption-meta').textContent = c.meta || '';
        if (q('caption-dur')) q('caption-dur').textContent = c.duration || '';

        // poster
        hasPoster = !!c.poster;
        if (poster) {
          if (c.poster) {
            poster.src = c.poster;
            poster.alt = c.title || '';
            poster.hidden = false;
          } else {
            poster.removeAttribute('src');
            poster.alt = '';
            poster.hidden = true;
          }
        }

        // video sources — full reset: pause, clear src + children, load new, reset time
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.innerHTML = '';
          (c.video_sources || []).forEach(function (src) {
            var s = document.createElement('source');
            s.src = src.url;
            s.type = src.type;
            video.appendChild(s);
          });
          video.loop = true; // preview mode loops
          video.muted = true;
          video.load();
          try { video.currentTime = 0; } catch (e) { /* ignore if not loaded yet */ }
          // If no poster, kick off the silent preview loop (first 3s)
          if (!hasPoster && video.querySelectorAll('source').length > 0) {
            video.play().catch(function () { /* autoplay blocked */ });
          }
        }

        // reset scrub
        if (scrubFill) scrubFill.style.width = '0%';
        if (scrubThumb) scrubThumb.style.left = '0%';

        // preview mode (not playing yet, not paused — fresh state)
        stage.classList.remove('is-playing');
        stage.classList.remove('is-paused');
        renderStatus();

        // active state on playlist + strips
        section.querySelectorAll('[data-chapter-row]').forEach(function (row) {
          row.classList.toggle('is-active', row.getAttribute('data-chapter-id') === id);
        });

        // reflect the active chapter in the URL (?chapter=<id>) so the page
        // is shareable — pasting that URL re-opens on this chapter.
        // replaceState (not pushState) keeps browser history uncluttered.
        try {
          var url = new URL(window.location.href);
          if (url.searchParams.get('chapter') !== c.id) {
            url.searchParams.set('chapter', c.id);
            window.history.replaceState({}, '', url.toString());
          }
        } catch (e) { /* older browsers */ }

        // desktop: scroll the playlist so the active chapter is visible
        // (only scrolls the playlist container, not the page)
        if (window.innerWidth > 749) {
          var listEl = section.querySelector('.leaf-theater__playlist');
          var activeEl = section.querySelector('.leaf-theater__pl-item.is-active');
          if (listEl && activeEl) {
            var itemTop = activeEl.offsetTop;
            var itemBottom = itemTop + activeEl.offsetHeight;
            var viewTop = listEl.scrollTop;
            var viewBottom = viewTop + listEl.clientHeight;
            // If already fully in view, leave it alone
            if (itemTop < viewTop || itemBottom > viewBottom) {
              var target = itemTop - (listEl.clientHeight / 2) + (activeEl.offsetHeight / 2);
              listEl.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
            }
          }
        } else {
          // mobile: each category renders as a horizontally-scrolling .mstrip. If the
          // active card isn't in view inside its strip, scroll the strip horizontally
          // to center it. Scrolls only the strip container — never the page.
          var activeCard = section.querySelector('.leaf-theater__mstrip-card.is-active');
          if (activeCard) {
            var strip = activeCard.closest('.leaf-theater__mstrip');
            if (strip && strip.scrollWidth > strip.clientWidth) {
              var cardRect = activeCard.getBoundingClientRect();
              var stripRect = strip.getBoundingClientRect();
              if (cardRect.left < stripRect.left || cardRect.right > stripRect.right) {
                var desired = activeCard.offsetLeft - (strip.clientWidth - activeCard.offsetWidth) / 2;
                var maxScroll = strip.scrollWidth - strip.clientWidth;
                if (desired < 0) desired = 0;
                if (desired > maxScroll) desired = maxScroll;
                strip.scrollTo({ left: desired, behavior: 'smooth' });
              }
            }
          }
        }
      }

      // ---- start full playback (from preview or from scratch) ----
      function startPlayback() {
        if (!video || !stage) return;
        hasPlayed = true;
        if (endOverlay) endOverlay.hidden = true;
        stage.classList.add('is-playing');
        video.loop = false; // full playback should end so we can show the replay/next overlay
        video.currentTime = 0;
        // respect the visitor's session-scoped mute preference (default muted).
        // startPlayback always follows a user gesture (play button, bubble click,
        // end-of-video next, etc.) so autoplay policies accept unmuted playback.
        // We don't reset the preference on failure — doing so would overwrite the
        // visitor's choice when earlier preview-loop play() calls abort (which is
        // normal when swap() is immediately followed by startPlayback()).
        video.muted = getMutedPref();
        video.play().catch(function () {});
        renderStatus();
      }

      // ---- show end-of-video overlay (replay current + play next) ----
      function showEndOverlay() {
        if (!endOverlay || !currentChapter) return;
        if (endReplayTitle) endReplayTitle.textContent = currentChapter.title || '';
        // find next chapter in the chapters array
        var idx = -1;
        for (var i = 0; i < data.chapters.length; i++) {
          if (data.chapters[i].id === currentChapter.id) { idx = i; break; }
        }
        var next = idx >= 0 ? data.chapters[idx + 1] : null;
        if (next && endNext && endNextTitle) {
          endNextTitle.textContent = next.title || '';
          endNext.hidden = false;
          endNext.setAttribute('data-end-next-id', next.id);
        } else if (endNext) {
          endNext.hidden = true;
        }
        endOverlay.hidden = false;
      }

      function togglePause() {
        if (!video || !hasPlayed) return;
        if (video.paused) video.play().catch(function () {});
        else video.pause();
        renderStatus();
      }

      // ---- video events ----
      if (video) {
        // preview-mode 1s loop via timeupdate
        video.addEventListener('timeupdate', function () {
          if (!hasPlayed && !hasPoster && video.currentTime >= 1) {
            video.currentTime = 0;
          }
        });
        video.addEventListener('pause', function () {
          if (stage) stage.classList.add('is-paused');
          renderStatus();
        });
        video.addEventListener('play', function () {
          if (stage) stage.classList.remove('is-paused');
          renderStatus();
        });
        video.addEventListener('ended', function () {
          if (hasPlayed) showEndOverlay();
        });
      }

      // ---- scrub progress — rAF loop, queries DOM fresh every frame,
      //      no closure dependencies so double-init / re-renders don't break it ----
      function scrubPoll() {
        var root = document.querySelector('[data-gs-section="video-theater"]');
        if (root) {
          var v = root.querySelector('[data-stage-video]');
          var s = root.querySelector('[data-stage]');
          var fill = root.querySelector('[data-scrub-fill]');
          var thumb = root.querySelector('[data-scrub-thumb]');
          if (v && s && fill && s.classList.contains('is-playing') && !v.paused && isFinite(v.duration) && v.duration > 0) {
            var pct = (v.currentTime / v.duration) * 100;
            fill.style.width = pct + '%';
            if (thumb) thumb.style.left = pct + '%';
          }
        }
        requestAnimationFrame(scrubPoll);
      }
      if (!window.__gs26ScrubPolling) {
        window.__gs26ScrubPolling = true;
        requestAnimationFrame(scrubPoll);
      }

      // ---- sync context + playlist heights to stage height ----
      // Stage has aspect-ratio 9:16 and max-width 400px, so its intrinsic height
      // is fixed by width. We use that to cap context and playlist — both scroll
      // internally if their content exceeds. This keeps the whole section at a
      // predictable height driven by the video.
      var context = section.querySelector('.leaf-theater__context');
      var playlist = section.querySelector('.leaf-theater__playlist');
      var stageEl = section.querySelector('[data-stage]');
      function syncColumnHeights() {
        if (!stageEl) return;
        if (window.innerWidth <= 749) {
          // mobile: no constraints (stacked layout, no side columns)
          if (context) context.style.maxHeight = '';
          if (playlist) playlist.style.maxHeight = '';
          return;
        }
        var stageH = stageEl.offsetHeight; // intrinsic aspect-ratio height
        if (stageH <= 0) return;
        var totalH = stageH + 56; // + stage-wrap vertical padding (28 + 28)
        if (context) context.style.maxHeight = totalH + 'px';
        if (playlist) playlist.style.maxHeight = totalH + 'px';
      }
      syncColumnHeights();
      window.addEventListener('resize', syncColumnHeights);
      if (video) {
        video.addEventListener('loadedmetadata', syncColumnHeights);
      }
      // Re-sync after a frame in case the stage hasn't laid out yet on first paint
      requestAnimationFrame(syncColumnHeights);
      // Observe stage size changes (e.g. responsive column width shifts)
      if (typeof ResizeObserver !== 'undefined') {
        try {
          var ro = new ResizeObserver(syncColumnHeights);
          ro.observe(stageEl);
        } catch (e) { /* older browser */ }
      }

      // ---- end-overlay buttons (replay + next) ----
      if (endReplay) {
        endReplay.addEventListener('click', function (e) {
          e.stopPropagation();
          startPlayback();
        });
      }
      if (endNext) {
        endNext.addEventListener('click', function (e) {
          e.stopPropagation();
          var nextId = endNext.getAttribute('data-end-next-id');
          if (nextId) {
            swap(nextId);
            startPlayback();
          }
        });
      }

      // ---- row clicks (playlist desktop + mobile strip cards) ----
      // Swap + scroll only. Preview state shows play button; user clicks it to play.
      section.querySelectorAll('[data-chapter-row]').forEach(function (row) {
        row.addEventListener('click', function () {
          var id = row.getAttribute('data-chapter-id');
          swap(id);
          if (stage) {
            stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });

      // ---- stage body click (not on interactive pieces) ----
      if (stage) {
        stage.addEventListener('click', function (e) {
          if (e.target.closest('[data-stage-no-toggle]')) return;
          if (!hasPlayed) startPlayback();
          else togglePause();
        });
      }

      // ---- big play ----
      if (bigPlay) {
        bigPlay.addEventListener('click', function (e) {
          e.stopPropagation();
          // If already played and just paused, resume from current time
          if (video && stage && stage.classList.contains('is-playing') && video.paused) {
            video.play().catch(function () {});
            return;
          }
          // Otherwise this is the first play — kick off full playback
          startPlayback();
        });
      }

      // ---- sound pill (toggle mute) ----
      if (soundPill) {
        soundPill.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!video) return;
          video.muted = !video.muted;
          setMutedPref(video.muted);
          renderStatus();
        });
      }

      // ---- fullscreen ----
      function updateFsIcons(isFs) {
        if (fsEnterIcon) fsEnterIcon.hidden = isFs;
        if (fsExitIcon) fsExitIcon.hidden = !isFs;
      }
      if (fullscreenBtn) {
        fullscreenBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var target = stage;
          if (document.fullscreenElement) {
            document.exitFullscreen();
          } else if (target && target.requestFullscreen) {
            target.requestFullscreen();
          } else if (video && video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          }
        });
        document.addEventListener('fullscreenchange', function () {
          updateFsIcons(!!document.fullscreenElement);
        });
      }

      // ---- scrub bar (click + drag) ----
      if (scrubTrack && video) {
        var dragging = false;
        function seekTo(e) {
          if (!video.duration) return;
          var rect = scrubTrack.getBoundingClientRect();
          var x = (e.clientX || (e.touches && e.touches[0].clientX) || 0) - rect.left;
          var fraction = Math.max(0, Math.min(1, x / rect.width));
          video.currentTime = fraction * video.duration;
          if (scrubFill) scrubFill.style.width = (fraction * 100) + '%';
          if (scrubThumb) scrubThumb.style.left = (fraction * 100) + '%';
        }
        scrubTrack.addEventListener('mousedown', function (e) {
          e.stopPropagation();
          dragging = true;
          scrubTrack.classList.add('is-scrubbing');
          if (!hasPlayed) startPlayback();
          seekTo(e);
        });
        document.addEventListener('mousemove', function (e) { if (dragging) seekTo(e); });
        document.addEventListener('mouseup', function () {
          dragging = false;
          scrubTrack.classList.remove('is-scrubbing');
        });
        scrubTrack.addEventListener('touchstart', function (e) {
          dragging = true;
          scrubTrack.classList.add('is-scrubbing');
          if (!hasPlayed) startPlayback();
          seekTo(e);
        }, { passive: true });
        scrubTrack.addEventListener('touchmove', function (e) { if (dragging) seekTo(e); }, { passive: true });
        scrubTrack.addEventListener('touchend', function () {
          dragging = false;
          scrubTrack.classList.remove('is-scrubbing');
        });
      }

      // ---- read-panel toggle ----
      var readToggle = section.querySelector('[data-read-toggle]');
      var readPanel = section.querySelector('[data-read-panel]');
      if (readToggle && readPanel) {
        readToggle.addEventListener('click', function () {
          var open = readPanel.classList.toggle('is-open');
          readToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          var body = readPanel.querySelector('.leaf-theater__read-body');
          if (body) body.hidden = !open;
        });
      }

      // ---- deep-link handling: ?chapter=<id> ----
      // Shareable URL — pasting e.g. /pages/getting-started-26?chapter=grip opens
      // the page scrolled to the theater with that chapter pre-loaded in preview
      // mode (user still has to press play, per the brief).
      function getDeepLinkChapterId() {
        try {
          var raw = new URLSearchParams(window.location.search).get('chapter');
          if (!raw) return null;
          var key = String(raw).trim();
          if (byId[key]) return key;
          var lower = key.toLowerCase();
          for (var k in byId) {
            if (String(k).trim().toLowerCase() === lower) return k;
          }
          return null;
        } catch (e) { return null; }
      }

      function scrollSectionIntoView() {
        // match the chip-nav click offset so the section lands below sticky header + chips
        var headerOffset = window.innerWidth <= 749 ? 56 + 48 : 65 + 48;
        var top = section.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
      }

      // ---- initial preview (first chapter, or deep-linked chapter) ----
      if (data.chapters.length > 0) {
        var deepLinkId = getDeepLinkChapterId();
        if (deepLinkId) {
          // full swap — sets up video, context, read panel, active row — in preview mode
          swap(deepLinkId);
          // defer scroll a couple frames so the theme header + chip nav have laid out
          requestAnimationFrame(function () {
            requestAnimationFrame(scrollSectionIntoView);
          });
        } else {
          var firstId = data.chapters[0].id;
          // lightweight initial setup — prime the preview without triggering playback state
          currentChapter = byId[firstId];
          hasPoster = !!(currentChapter && currentChapter.poster);
          if (video && !hasPoster && currentChapter && currentChapter.video_sources && currentChapter.video_sources.length) {
            video.muted = true;
            video.currentTime = 0;
            video.play().catch(function () {});
          }
          renderStatus();
        }
      }

      // ---- expose global ----
      window.playVideoById = function (id) {
        swap(id);
        startPlayback();
        if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
